import React, { useState, useEffect } from 'react';
import present from './images/present.svg';
import axios from 'axios';

const Note = (props) => {
	const [dice, _dice] = useState(props.login.firstLanch);
	const [phrases, _phrases] = useState([''])
	const [count, _count] = useState(0);

	useEffect(() => {
		// first

		return () => {
			renderWishlists()
		}
	}, [dice])

	const renderWishlists = () => {
		return (
			<div className="note">
				<h5 className="note__title">Привет, {decodeURI(props.name.replace("%20", " "))}!</h5>
				<h5>Ты тайный санта для <span className="note__santa">{props.decryptHash(props.mykey)}</span>.</h5>
				<div style={{ display: 'flex', maxWidth: 192, margin: '1rem auto', width: 'fit-content' }}>
					{props.wishlist.map((item, index) => {
						return <a href={item} target='_blank' referrerPolicy="no-referrer" rel="noopener noreferrer" key={index}><img src={present} title={item} className="note__image" alt="present" /></a>
					})}
				</div>
				<h5>Желаю Удачи!</h5>
			</div>
		)
	}

	// const intervalId = setInterval(() => {
	// 	_count(count + 1)
	// }, 2000);

	// setTimeout(() => {
	// 	_count(count + 1)
	// }, 2000);

	const renderAnimation = () => {
		setTimeout(() => {
			_dice(false);

			// clearInterval(intervalId);

			axios.post(`${window.location.protocol}//${window.location.hostname}/api/updFirstLanch/${props.login.name}`)
				.then(function (response) {
					console.log(response);
				})
				.catch(function (error) {
					console.log(error);
				});
		}, 3000);

		return (
			<div className="note">
				<h5 className="note__title">Привет, {decodeURI(props.name.replace("%20", " "))}!</h5>
				<h5 key={count} style={{ color: 'grey' }}>{phrases[count]}</h5>
				<div class="dice" style={{ margin: '53px auto' }}>
					<div class="side one"></div>
					<div class="side two"></div>
					<div class="side three"></div>
					<div class="side four"></div>
					<div class="side five"></div>
					<div class="side six"></div>
				</div>
			</div>
		)
	}

	return (
		<div className="people-container">

			{dice ? renderAnimation() : renderWishlists()}

		</div>
	)
}

export default Note;